// VoiceRecorder.js — bouton d'ENREGISTREMENT d'un message vocal (MediaRecorder → upload backend).
// N'apparaît QUE si REACT_APP_VOICE_MESSAGES_ENABLED=true (sinon renvoie null). Rien de payant.
import React, { useRef, useState } from 'react';
import { FiMic, FiSquare } from 'react-icons/fi';
import { theme } from '../theme';
import { VOICE_ENABLED, uploadAudio } from '../services/chatMedia';

export default function VoiceRecorder({ onAudio }) {
  const [rec, setRec] = useState(false);
  const [busy, setBusy] = useState(false);
  const mrRef = useRef(null);
  const chunksRef = useRef([]);

  if (!VOICE_ENABLED) return null; // fonctionnalité désactivée → bouton masqué

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      chunksRef.current = [];
      mr.ondataavailable = (e) => { if (e.data.size) chunksRef.current.push(e.data); };
      mr.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        const blob = new Blob(chunksRef.current, { type: mr.mimeType || 'audio/webm' });
        setBusy(true);
        const url = await uploadAudio(blob);
        setBusy(false);
        if (url && onAudio) onAudio(url);
      };
      mrRef.current = mr; mr.start(); setRec(true);
    } catch { /* micro refusé → on ne fait rien */ }
  };
  const stop = () => { try { mrRef.current && mrRef.current.stop(); } catch { /* */ } setRec(false); };

  return (
    <button
      type="button" onClick={rec ? stop : start} disabled={busy}
      title={rec ? 'Arrêter et envoyer' : 'Message vocal'}
      style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: rec ? '#ef4444' : theme.colors.textSecondary, display: 'inline-flex', alignItems: 'center', padding: '0 .3rem' }}
    >
      {rec ? <FiSquare /> : <FiMic />}
    </button>
  );
}
